import { render, staticRenderFns } from "./code_transfer.vue?vue&type=template&id=0dac3142&scoped=true"
import script from "./code_transfer.vue?vue&type=script&lang=js"
export * from "./code_transfer.vue?vue&type=script&lang=js"
import style0 from "./code_transfer.vue?vue&type=style&index=0&id=0dac3142&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dac3142",
  null
  
)

export default component.exports